export default "__VITE_ASSET__C$F9RvxU__"